import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import { getPartyMaster, listGeneralSetting } from "../../../graphql";
import { useSelector } from "react-redux";
import { useStateList } from "./HandleInvoiceStateProvider";

function UseVoucherDetails() {
     let getCompany = useSelector(
        (state) => state?.companyReducer?.companyDetails
      );
  const [voucherDetails, setVoucherDetails] = useState([]);
  const {setData}=useStateList()
  const getVoucherDetails = async (Type) => {
  
    try {
      const resSerialVouchers = await API.graphql(
            graphqlOperation(listGeneralSetting, {
              entrytypecd:Type ,
              financialyearid: getCompany.financialyearid,
            })
          );
      if (resSerialVouchers?.data?.listGeneralSetting?.length > 0) {
        
        
        const recVoucherList = resSerialVouchers.data.listGeneralSetting;
        console.log("recVoucherList",recVoucherList);
        setData((prev)=>({
            ...prev,
            transactionSeries:{label:recVoucherList?.[0]?.serialnumber,value:recVoucherList?.[0]?.serialnumber},
            transactionVoucher:recVoucherList?.[0]?.prefix + recVoucherList?.[0]?.nextinvoicenumber + recVoucherList?.[0]?.suffix,

        }))

        setVoucherDetails(recVoucherList);
      }else{
        setVoucherDetails([]);
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  
 
  return { getVoucherDetails, voucherDetails };
}

export default UseVoucherDetails;
